import React, { SVGProps } from 'react';

export const BelegoIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width="100%"
      height="100%"
      fill="none"
      {...props}
    >
      <g transform="translate(7, -10)">
        {/* Back Document */}
        <path
          d="M22 38 C18.686 38 16 40.686 16 44 L16 88 C16 91.314 18.686 94 22 94 L54 94 C57.314 94 60 91.314 60 88"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Middle Document */}
        <path
          d="M28 32 C24.686 32 22 34.686 22 38 L22 82 C22 85.314 24.686 88 28 88 L60 88 C63.314 88 66 85.314 66 82"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Front Document Base */}
        <path
          d="M34 26 L54 26 L68 40 L68 76 C68 79.314 65.314 82 62 82 L34 82 C30.686 82 28 79.314 28 76 L28 32 C28 28.686 30.686 26 34 26 Z"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Front Document Fold */}
        <path
          d="M54 26 L54 36 C54 38.209 55.791 40 58 40 L68 40"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Green Checkmark */}
        <path
          d="M36 60 L46 70 L70 44"
          stroke="var(--logo-accent, #7BD39D)"
          strokeWidth="7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default BelegoIcon;